import { Link } from "@mui/material";
import { styled } from "@mui/material/styles";
const Slot = styled(Link)(({ theme }) => ({
  width: 64,
  height: 40,
  borderRadius: 8,
  fontSize: 14,
  letterSpacing: 0.25,
  lineHeight: "20px",
  marginRight: 2,
  marginLeft: 1,
  marginBottom: 8,
  backgroundColor: "#fff",
  border: `1px solid ${theme.palette.primary[800]}`,
  color: theme.palette.primary[800],
  ...theme.typography["Lato Emphasized 2"],
  "&.selected": {
    backgroundColor: "#F3A987",
    "&.priority-highest, &.priority-medium, &.priority-lowest": {
      color: "#ffffff"
    },
    "&.priority-highest": {
      backgroundColor: theme.palette.primary[800]
    },
    "&.priority-medium": {
      backgroundColor: theme.palette.warning[700]
    },
    "&.priority-lowest": {
      backgroundColor: theme.palette.error[800]
    }
  },
  "&.priority-highest": {
    color: theme.palette.primary[800],
    borderColor: theme.palette.primary[800]
  },
  "&.priority-medium": {
    color: theme.palette.warning[700],
    borderColor: theme.palette.warning[700]
  },
  "&.selected.priority-medium": {
    backgroundColor: theme.palette.warning[700]
  },
  "&.priority-lowest": {
    color: theme.palette.error[800],
    borderColor: theme.palette.error[800]
  },
  "&.selected.priority-lowest": {
    backgroundColor: theme.palette.error[800]
  }
}));
export {
  Slot
};
